import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  createGenericSlice,
  createReducers,
  ExtraReducers,
  GenericState,
} from 'stores/generics'
import { Payload } from 'stores'
import { PaymentReservationResponse } from '@types'
import { STORE_STATUS_INITIALIZED, STORE_RESERVATION } from 'constants/store'
import { ReservationError } from 'constants/enums'

type PaymentReservationDataError = {
  error?: ReservationError
}

type State = GenericState<
  PaymentReservationResponse,
  PaymentReservationDataError
>

export const initialState: State = {
  data: {
    id: '',
    available_limit_cents: 0,
  },
  status: STORE_STATUS_INITIALIZED,
  error: null,
}

export const fetchReservation = createAsyncThunk<
  PaymentReservationResponse,
  Promise<PaymentReservationResponse>,
  Payload<PaymentReservationDataError, PaymentReservationResponse>
>(
  STORE_RESERVATION,
  async (promise: Promise<PaymentReservationResponse>, { rejectWithValue }) => {
    try {
      const response = await promise
      return response
    } catch (e: any) {
      return rejectWithValue({
        code: e.errorCode,
        message: e.error,
        details: e.data,
      })
    }
  }
)

const extraReducers: ExtraReducers = createReducers<
  PaymentReservationResponse,
  PaymentReservationResponse,
  Payload<PaymentReservationDataError, PaymentReservationResponse>
>(fetchReservation, initialState.data)

const listSlice = createGenericSlice({
  name: STORE_RESERVATION,
  initialState,
  reducers: {},
  extraReducers,
})

const { actions, reducer } = listSlice

const { clear, success } = actions

export { clear, success }

export default reducer
